import { DOCS_ACCESS_PRESENTATION_VERSION } from '@nadoutong/contracts';

/**
 * Unknown `presentation_version` is the first conservative fallback:
 * do not render the served document at all. Additive optional members
 * do not bump the version; only an incompatible shape does.
 */
export function isSupportedDocsPresentationVersion(version: number): boolean {
  return version === DOCS_ACCESS_PRESENTATION_VERSION;
}

/**
 * Closed set of block types this renderer draws. An unknown `type` is
 * skipped (the second conservative fallback); the rest of the section
 * still renders.
 */
export function isKnownDocsBlockType(type: string): boolean {
  switch (type) {
    case 'callout':
    case 'snippet':
    case 'param_table':
    case 'steps':
    case 'checklist':
    case 'key_values':
    case 'link':
      return true;
    default:
      return false;
  }
}
